export default __webpack_public_path__ + "static/media/liquidity-bg.cb7aebd0.png";